var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPrinter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.6 2v3.556h-.9c-1.485 0-2.7 1.2-2.7 2.666v6.222h3.6V18h10.8v-3.556H19V8.222c0-1.466-1.215-2.666-2.7-2.666h-.9V2zm1.8 1.778h7.2v1.778H6.4zM3.7 7.333h12.6c.497 0 .9.399.9.89v4.444h-1.8v-1.778H4.6v1.778H2.8V8.222c0-.49.403-.889.9-.889m11.7.89c-.497 0-.9.397-.9.888s.403.889.9.889.9-.398.9-.889a.894.894 0 0 0-.9-.889zm-9 4.444h7.2v3.555H6.4z"
})));
export default SvgIconPrinter;